module.exports = __webpack_public_path__ + "static/img/cdms_test_logo.d1519d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cdms_test_logo.png
// module id = NfTq
// module chunks = 196